import React, { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import {
  getFilteredEmployees,
  countemployeesInMission,
  getChargesByOrdreDeMissionsForCurrentMonth,
} from "../../../../services/RHService/OrdreDeMissionService";
import getCurrentUserId from "../../../../reduxSaga/sagas/requests/currentUserId";

const Missionlist = () => {
  //variables
  const [isVisible, setIsVisible] = useState(false);
  const [filter, setFilter] = useState("");
  const [employees, setEmployees] = useState([]);
  const [employeeMissionCount, setEmployeeMissionCount] = useState(0);
  const [charges, setCharges] = useState(0.0);

  useEffect(() => {
    const fetchChargesByOrdreDeMissionsForCurrentMonth = async () => {
      try {
        const userId = getCurrentUserId();
        const response = await getChargesByOrdreDeMissionsForCurrentMonth(
          userId
        );
        console.log("response ----------->", response);
        // return;
        // if (response && response.success) {
        setCharges(response.success);
        // } else {
        //   console.error("Invalid response:", response);
        // }
      } catch (error) {
        console.error("Error fetching charges:", error);
      }
    };

    fetchChargesByOrdreDeMissionsForCurrentMonth();
  }, []);
  const fetchEmployeeMissionCount = useCallback(async () => {
    try {
      const response = await countemployeesInMission(getCurrentUserId());

      setEmployeeMissionCount(response.data);
    } catch (error) {
      console.error(error);
    }
  }, []);
  useEffect(() => {
    fetchEmployeeMissionCount();
  }, [fetchEmployeeMissionCount]);
  //filter by cin and firstname or lastname
  const filteredData1 = employees
    ? employees.filter((item) => {
        const lowerCaseFilter = filter.toLowerCase();
        return (
          (item.cin && item.cin.toLowerCase().includes(lowerCaseFilter)) ||
          (item.firstname &&
            item.firstname.toLowerCase().includes(lowerCaseFilter)) ||
          (item.lastname &&
            item.lastname.toLowerCase().includes(lowerCaseFilter))
        );
      })
    : [];
  useEffect(() => {
    getFilteredEmployees(getCurrentUserId(), filter).then((resp) =>
      setEmployees(resp)
    );
  }, [filter]);

  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      {/* header */}
      <div className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h1 className="m-0">Ordre de mission</h1>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  <i class="fa-solid fa-house"></i>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/">Home</Link>
                </li>
                <li className="breadcrumb-item active">
                  Liste des ordres de mission
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <div class="container-fluid">
        <div class="row ">
          <div className="col-md-6 col-lg-6 col-sm-12 mb-2">
            <div class="small-box bg-dark">
              <div class="inner">
                <h3>{employeeMissionCount ? employeeMissionCount : 0}</h3>
                <p>En Mission</p>
              </div>
              <div class="icon">
                <i class="fa-solid fa-route"></i>
              </div>
              <Link to="/employeemissionlist" class="small-box-footer">
                Plus d'informations
                <i class="fas fa-arrow-circle-right m-1"></i>
              </Link>
            </div>
          </div>
          <div className="col-md-6 col-lg-6 col-sm-12  mb-2 ">
            <div class="small-box bg-dark" style={{ height: "141px" }}>
              <div class="inner">
                <h3>{charges ? charges : 0.0} DT</h3>
                <p>Charge de ce mois</p>
              </div>
              <div class="icon">
                <i class="fa-solid fa-money-check-dollar"></i>
              </div>
            </div>
          </div>
        </div>
        <div></div>
        <div class="card">
          <div className="row">
            <div className="col-lg-6">
              {/* input search */}
              <input
                type="text"
                className="form-control form-control-border form-control-lg"
                placeholder="Chercher par CIN Nom Prenom ..."
                value={filter}
                onChange={(e) => {
                  setFilter(e.target.value);
                  setIsVisible(true);
                }}
              />
            </div>
          </div>
        </div>
        <div class="card">
          {/* table de mission (set invisible and when tap to search it will visible) */}
          {isVisible &&
            (employees.length === 0 || filteredData1.length === 0 ? (
              <table
                class="table"
                style={{ display: filter.length === 0 ? "none" : "table" }}
              >
                <thead class="thead-dark">
                  <tr>
                    <th scope="col">Mat.</th>
                    <th scope="col">Personnel</th>
                    <th scope="col">CIN</th>
                    <th scope="col">Contrat</th>
                    <th scope="col">equipe</th>
                    <th scope="col">Poste</th>
                    <th scope="col">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th colSpan="7" style={{ textAlign: "center" }}>
                      Pas de résultat, Veuillez vérifier!
                    </th>
                  </tr>
                </tbody>
              </table>
            ) : (
              <table
                class="table"
                style={{ display: filter.length === 0 ? "none" : "table" }}
              >
                <thead class="thead-dark">
                  <tr>
                    <th scope="col">Mat.</th>
                    <th scope="col">Personnel</th>
                    <th scope="col">CIN</th>
                    <th scope="col">email</th>
                    <th scope="col">Phone</th>
                    <th scope="col">Contrat</th>

                    <th scope="col">Poste</th>
                    <th scope="col">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredData1.map((employee, index) => (
                    <tr key={employee.id}>
                      <td>{index + 1}</td>
                      <td>
                        {employee.firstname} {employee.lastname}
                      </td>
                      <td>{employee.cin}</td>
                      <td>{employee.email}</td>
                      <td>{employee.phone}</td>
                      <td>{employee.contractType}</td>
                      <td>{employee.nomPost}</td>
                      <td>
                        {!employee.estAffecter ? (
                          <div>
                            <Link
                              to={`/addmission?idUser=${employee.idPersonnel}`}
                              className="btn btn-primary d-flex"
                            >
                              Affecter un ordre de mission
                            </Link>
                          </div>
                        ) : (
                          <Link to="" className="btn btn-danger">
                            En mission
                          </Link>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ))}
        </div>
      </div>
    </div>
  );
};
export default Missionlist;
